<mat-card class="example-card">
    <mat-card-header class="card-header">
      <mat-card-title class="card-titulo">Gestión de Tipo Movimiento</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>
  
    <mat-card-content>
  
      <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>
  
      <div *ngIf="!isSearching && item != null">
  
        <ng-container *ngIf="canEdit">
  
          <form [formGroup]="formGroup">
  
            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline"  style="width: 100%">
                  <mat-label class="text-style">Código</mat-label>
                  <input class="text-style" matInput formControlName="Codigo" >
                  <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                    {{ getErrorCodigo() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline"  style="width: 100%">
                  <mat-label class="text-style">Nombre*</mat-label>
                  <input class="text-style" matInput formControlName="Nombre" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Signo*</mat-label>
                  <mat-select formControlName="Signo">
                    <mat-option *ngFor="let s of signoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['Signo'].valid && formGroup.controls['Signo'].touched">
                    {{ getErrorSigno() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoSearching">Grupo de Movimiento*</mat-label>
                  <mat-label *ngIf="isTipoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoMovimientoEnum">
                    <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['TipoMovimientoEnum'].valid && formGroup.controls['TipoMovimientoEnum'].touched">
                    {{ getErrorTipoMovimientoEnum() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <ng-container *ngIf="formGroup?.get('Signo')?.value == -1 && canRecurrente">

                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                  <mat-checkbox formControlName="EsRecurrente" (keyup.enter)="onGuardar()" color="primary">Los movimientos de este tipo son recurrentes?</mat-checkbox> 
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="formGroup?.get('EsRecurrente')?.value == true">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Periodicidad de Recurrencia (días)*</mat-label>
                    <input matInput type="number" formControlName="PeriodicidadRecurrencia" (keyup.enter)="onGuardar()" maxlength="10">
                    <!-- <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                      {{ getErrorNombre() }}
                    </mat-error> -->
                  </mat-form-field>
                </div>

              </ng-container>

              <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;" *ngIf="tenantFeatureFlags?.HabilitarControlGastos">
                <mat-checkbox class="text-style" formControlName="EsDefaultGasto" (keyup.enter)="onGuardar()" color="primary">Es Default para Gasto?</mat-checkbox>
              </div>
              <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
                <mat-checkbox class="text-style" formControlName="EsDefaultPedido" (keyup.enter)="onGuardar()" color="primary">Es Default para Pedido?</mat-checkbox>
              </div>
              <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;" *ngIf="tenantFeatureFlags?.HabilitarControlContratos">
                <mat-checkbox class="text-style" formControlName="EsDefaultContrato" (keyup.enter)="onGuardar()" color="primary">Es Default para Contrato?</mat-checkbox>
              </div>

              <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                <mat-checkbox class="text-style" formControlName="Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
              </div>
             
            </div>
  
          </form>
  
        </ng-container>
  
        <ng-container *ngIf="!canEdit">
  
          <div fxLayout="row stretch" class="zb-readonly">
  
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Código</b>: {{item.Codigo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Nombre</b>: {{item.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Signo</b>: {{item.Signo > 0 ? 'Positivo' : 'Negativo'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> 
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Grupo de Movimiento</b>: {{item.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> 

            <ng-container *ngIf="canRecurrente">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Es Recurrente</b>: {{item.EsRecurrente ? 'Sí' : 'No'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.EsRecurrente">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Periodicidad de Recurrencia (días)</b>: {{item.PeriodicidadRecurrencia | number: '1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </ng-container>
            
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlGastos">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Es Default para Gasto</b>: {{item.EsDefaultGasto ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Es Default para Pedido</b>: {{item.EsDefaultPedido ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlContratos">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Es Default para Contrato</b>: {{item.EsDefaultContrato ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
  
          </div>
  
        </ng-container>
  
      </div>
  
    </mat-card-content> 
    <mat-card-actions style="margin-bottom: 10vh;">
      <div class="flex-actions">
        <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
        <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
        <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isProcessing()" color="secondary" class="zb-button">
          {{isDeleting ? 'Eliminando...' : 'Eliminar' }}
        </button>
      </div>
  </mat-card-actions>
  
  </mat-card>